  import React, { createContext, useContext, useEffect } from 'react';
  import common from "../config/common.json";

  const defaultValue = {};

  const UIContext = createContext(defaultValue);

  export default function UIProvider({ children }) {

    useEffect(()=>{
      if(document.body){
        var bodyStyles = document.body.style;
        bodyStyles.setProperty('--primary-color', common.primary_color);
         bodyStyles.setProperty('--secondary-color', common.secondary_color);
         bodyStyles.setProperty('--header-title', common.header_title);
        // bodyStyles.setProperty('--grey-color', common.grey_color); 
        // bodyStyles.setProperty('--dark-gray-home', common.dark_grey_home);
        document.getElementById('title').innerHTML=common.app_name;
        document.getElementById("fabicon").href=`../${common.ClientId}_fabicon.png`;
        // document.getElementById("touch-icon").href=`../${common.ClientId}_fabicon.png`;
      }
    },[])
    return (
      <UIContext.Provider  value={{  }}>
        {children}
      </UIContext.Provider>
    );
  }

  export function useUIState() {
    const context = useContext(UIContext);
    return context;
  }